export interface Comercializacion {
  id: number;
  actividad_id: number;
  tipo_comercializacion_id: number;
  grupo_especie_id: number;
}

export interface ComercializacionBackend {
  comercializaciones: Comercializacion[]
}

export function createEmptyComercializacion(): Comercializacion {
  return {
    id: null,
    actividad_id: null,
    tipo_comercializacion_id: null,
    grupo_especie_id: null
  };
}

export function createComercializacion(params: any): Comercializacion {
  return {
    ...createEmptyComercializacion(),
    ...params
  };
}
